// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';
import {addRemoveModalClass} from '../../../shared/services/add-remove-modal-class';

export const updateNewTransferStatusChangeModal = (name, value) =>

    dispatch => {

        if (name === 'isVisible') {

            addRemoveModalClass(value);

        }

        dispatch({
            name,
            type: actions.UPDATE_NEW_TRANSFER_STATUS_CHANGE_MODAL,
            value
        });

    };



// WEBPACK FOOTER //
// ./src/product/new-transfer/action-creators/new-transfer-status-change-modal.js